import PatientsList from "../components/patients/PatientsList";
import PatientPresumptive from "../components/patients/PatientPresumptive";
import AddPatients from "../components/patients/AddPatients";
import EditPatients from "../components/patients/EditPatients";
import PatientsProfile from "../components/patients/PatientsProfile";

export default [
  {
    path: "patients",
    element: <PatientsList />,
  },
  {
    path: "patientpresumptive",
    element: <PatientPresumptive />,
  },
  {
    path: "addpatients",
    element: <AddPatients />,
  },
  {
    path: "editpatients",
    element: <EditPatients />,
  },
  {
    path: "patient/profile/:id",
    element: <PatientsProfile />,
  },
];
